import { Button, LabeledContainer } from '@schibsted-svp/react-ui';
import { useLiveArchiveExpirationQuery, useLiveArchiveQuery } from 'services/admin-bff-sdk';
import { useEffect, useState } from 'react';
import QuestionMark from 'components/ui/QuestionMark';
import css from './PrepareClipDownload.module.scss';

type PrepareClipDownloadProps = {
    assetId: number;
    provider: string;
    assetStreamType: string;
    disabled: boolean;
    onClick: React.ComponentProps<typeof Button>['onClick'];
    loading: boolean;
};

const POLLING_INTERVAL = 20000;

export function PrepareClipDownload({
    assetId,
    provider,
    assetStreamType,
    disabled,
    onClick,
    loading,
}: PrepareClipDownloadProps) {
    const [pollingInterval, setPollingInterval] = useState(POLLING_INTERVAL);

    const { isError: isLiveArchiveError, data: liveArchiveData } = useLiveArchiveQuery({ newsroom: provider, assetId });

    const { isError: isLiveArchiveExpirationError, data: liveArchiveExpirationData } = useLiveArchiveExpirationQuery(
        { assetId, provider },
        { pollingInterval, skip: !liveArchiveData?.liveArchive }
    );

    const isClipDownloadPending = liveArchiveData?.liveArchive && !liveArchiveExpirationData?.liveArchiveExpiration;

    const isLive = assetStreamType === 'live';

    useEffect(() => {
        if (liveArchiveExpirationData?.liveArchiveExpiration) {
            setPollingInterval(0);
        }
    }, [liveArchiveExpirationData?.liveArchiveExpiration]);

    if (!liveArchiveData?.liveArchive) {
        return null;
    }

    if (isLiveArchiveError || isLiveArchiveExpirationError) {
        return null;
    }

    return (
        <div className={css.clipDownload}>
            <LabeledContainer>
                <Button
                    type="button"
                    size="small"
                    disabled={disabled || isClipDownloadPending}
                    onClick={onClick}
                    loading={loading}
                >
                    Prepare download
                </Button>
            </LabeledContainer>
            {isLive && (
                <QuestionMark
                    className={css.clipDownloadInfo}
                    content="Up to 60 seconds at the end of the live video may be unavailable in the downloaded file."
                />
            )}
        </div>
    );
}
